// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadSpinner_container__jNVDS","opacityBack":"UploadSpinner_opacityBack__1_ZOK","spinnerStyle":"UploadSpinner_spinnerStyle__2Iptv"};